import React from 'react'
import Badge, { BadgeVariant } from '@components/DesignSystem/Badge'
import { useTranslation } from '@i18n'
import tw, { styled } from 'twin.macro'
import { AutosaveStatusType, useArticleContext } from '../_core'
import SuccessToast from '../toast/SuccessToast'
import FailToast from '../toast/FailToast'

const StyledBadge = styled(Badge)`
  ${tw`hidden md:inline`}
`

export const useAutosaveLabel = (autosaveStatus: string) => {
  const { t } = useTranslation('editor')

  return t('autosave.label', { context: autosaveStatus.toLowerCase() })
}

function AutosaveIndicator() {
  const {
    articleState: { autosaveStatus },
  } = useArticleContext()
  const autosaveLabel = useAutosaveLabel(autosaveStatus)

  return (
    <>
      <StyledBadge variant={BadgeVariant.default}>{autosaveLabel}</StyledBadge>
      {autosaveStatus === AutosaveStatusType.SUCCEEDED && <SuccessToast />}
      {autosaveStatus === AutosaveStatusType.FAILED && <FailToast />}
    </>
  )
}

export default AutosaveIndicator
